import React from 'react'
import * as S from './styles'

const Footer = () => {
  return (
    <S.Footer>
      Made with &#9829; by Yash Kurzekar{'  '}•{'  '}
      
    </S.Footer>
  )
}

export default Footer
